module.exports = __webpack_public_path__ + "images/515daa22c6ef667241200db940c8ec50.png";